export default {
	title: "Rituais",
	dateTime: "Data e Horário",
	notFinished: "Não finalizado",
	edit: "Editar Ritual",
	create: "Criar Ritual",
	notFound: "Ritual não encontrado",
	loading: "Carregando ritual...",
	createdBy: "Criado por",
	deleteConfirmation: "Deseja realmente excluir o ritual {title}?",
	deleteWarning: "Todas as fichas, retornos e mensagens vinculadas a este ritual serão excluídos permanentemente.",
	deleteCodeInstruction: "Para confirmar, digite o código {code}:",
	startWarning: "Ao iniciar o ritual, fichas poderão ser distribuídas e chamadas.",
	startCodeInstruction: "Para confirmar, digite o código {code}:",
	status: {
		label: "Status",
		scheduled: "Agendado",
		inProgress: "Em Andamento",
		in_progress: "Em Andamento",
		completed: "Concluído",
		cancelled: "Cancelado",
		closed: "Fechado",
	},
	form: {
		titleLabel: "Título do Ritual",
		titleHint: "Título que identifica o ritual",
		descriptionLabel: "Descrição",
		descriptionHint: "Descrição detalhada do ritual",
		ritualTypeLabel: "Tipo de Ritual",
		ritualTypeHint: "Selecione o tipo de ritual",
		statusLabel: "Status",
		statusHint: "Status atual do ritual",
		dateLabel: "Data",
		dateHint: "Data em que o ritual será realizado",
		startTimeLabel: "Horário de Início",
		startTimeHint: "Horário de início do ritual (obrigatório)",
		startDateLabel: "Data e Hora de Início",
		endDateLabel: "Data e Hora de Fechamento",
		locationLabel: "Local",
		locationHint: "Local onde o ritual será realizado",
		isPublicLabel: "Publicar na agenda pública",
		isPublicHint: "Torna este ritual visível na página pública do templo",
		acceptsReservationsLabel: "Aceitar reservas",
		acceptsReservationsHint: "Permite que as pessoas reservem presença neste ritual",
		publicNotesLabel: "Observações públicas",
		publicNotesHint: "Texto exibido na agenda pública (opcional)",
		retroactiveWarning:
			"Data no passado: este ritual será criado como lançamento retroativo. Ele nasce como Agendado — lance as fichas e use \"Fechar Ritual\" para registrá-lo, sem precisar iniciá-lo.",
	},
	retroactive: {
		badge: "Lançamento retroativo",
	},
	table: {
		title: "Título",
		headers: {
			title: "Título",
			public: "Público",
		},
		public: {
			yes: "Na agenda pública",
			no: "Não publicado",
		},
	},
	tabs: {
		details: "Detalhes",
		tickets: "Fichas de Atendimento",
		stats: "Estatísticas",
		report: "Relatório",
		messages: "Mensagens",
		returns: "Retornos",
	},
	lists: {
		pdf: "PDF",
		xlsx: "XLSX",
		sortCreated: "Ordem de criação",
		sortTarget: "Ordem de destino",
		sortAlpha: "Ordem alfabética",
		messagesEmpty: "Nenhuma mensagem registrada neste ritual",
		returnsEmpty: "Nenhum retorno vinculado a este ritual",
		groupEmpty: "Nenhum retorno neste grupo",
		createdHere: "Criados neste ritual",
		fulfilledHere: "Cumpridos neste ritual",
		markedHere: "Marcados para este ritual",
		createdBy: "Criado por",
	},
	actions: {
		delete: "Excluir",
		start: "Iniciar",
		complete: "Finalizar",
		cancel: "Cancelar",
	},
	filters: {
		search: "Buscar rituais...",
		date: "Data",
		today: "Hoje",
		thisWeek: "Esta semana",
		thisMonth: "Este mês",
		dateFrom: "Data inicial",
		dateTo: "Data final",
		status: "Status",
		ritualType: "Tipo de Ritual",
	},
	details: {
		ritualType: "Tipo de Ritual",
		noTicketsDescription: "Nenhuma ficha de atendimento registrada para este ritual",
	},
	messages: {
		created: "Ritual '{title}' criado com sucesso",
		updated: "Ritual '{title}' atualizado com sucesso",
		deleted: "Ritual '{title}' excluído com sucesso",
		statusUpdated: "Status do ritual '{title}' alterado para {status}",
		createError: "Erro ao criar ritual",
		updateError: "Erro ao atualizar ritual",
		deleteError: "Erro ao excluir ritual",
		statusUpdateError: "Erro ao atualizar status do ritual",
		loadError: "Erro ao carregar rituais",
		editDisabled: "Rituais concluídos ou cancelados não podem ser editados",
		deleteDisabled: "Rituais cancelados, em andamento ou concluídos não podem ser excluídos",
		cancelDisabled: "Rituais cancelados ou concluídos não podem ser cancelados",
		startDisabled: "Apenas rituais agendados podem ser iniciados",
	},
	confirmations: {
		start: "Tem certeza que deseja iniciar este ritual?",
		complete: "Tem certeza que deseja finalizar este ritual?",
		cancel: "Tem certeza que deseja cancelar este ritual? Esta ação não pode ser desfeita.",
		delete: "Tem certeza que deseja excluir o ritual '{title}'? Esta ação não pode ser desfeita.",
	},
	confirmStatusChange: "Confirmar Mudança de Status",
	statusChangeConfirmation: "Tem certeza que deseja alterar o status do ritual '{title}' para {status}?",
	empty: {
		title: "Nenhum ritual encontrado",
		subtitle: "Crie o primeiro ritual do sistema",
		button: "Criar Ritual",
		dependencyWarning: "Para criar rituais, é necessário cadastrar tipos de atendimento e tipos de rituais primeiro.",
	},
	stats: {
		total: "Total",
		scheduled: "Agendados",
		inProgress: "Em Andamento",
		completed: "Concluídos",
		cancelled: "Cancelados",
		pending: "Pendentes",
		statusDistribution: "Distribuição por Status",
		perCardBreakdown: "Fichas por Mesa de Atendimento",
		tickets: "fichas",
		attendanceTime: "Tempo de Atendimento por Mesa",
		avgTime: "Tempo médio",
		minutes: "minutos",
		acceptableLimit: "Limite (15 min)",
		noTickets: "Nenhuma ficha registrada para este ritual",
		noTicketsSubtitle: "As estatísticas aparecerão quando fichas forem distribuídas",
		loadError: "Erro ao carregar estatísticas",
	},
	validation: {
		titleRequired: "Título é obrigatório",
		titleMaxLength: "Título deve ter no máximo 100 caracteres",
		ritualTypeRequired: "Tipo de ritual é obrigatório",
		dateRequired: "Data é obrigatória",
		startTimeRequired: "Horário de início é obrigatório",
		locationMaxLength: "Local deve ter no máximo 200 caracteres",
		descriptionMaxLength: "Descrição deve ter no máximo 500 caracteres",
		publicNotesMaxLength: "Observações públicas devem ter no máximo 500 caracteres",
		activeRitualExists: "Já existe um ritual em andamento. Apenas um ritual pode estar ativo por vez.",
		invalidTime: "Formato de horário inválido",
		statusRequired: "Status é obrigatório",
	},
};
